import {
  planTypes,
  dependMeetingPlanTypeList,
  billingCycleDependBasePlanTypeList,
  BASE_PLAN_SUB_TYPES,
  PlanModelInfo,
} from '@/common/constants';
import { defaultMapper } from '@/common/service/default-mapper';
import { pageConfig } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { planUnitMap } from '@/common/product-unit'

const RoomConnectorCategories = {
  ROOM_CONNECTOR: 'rc',
};

const reorderDependBasePlans = (urlPlan, planTypeList) => {
  const index = planTypeList.findIndex(plan => plan === urlPlan);
  // Not the first one.
  if(index > 0) {
    const newPlanTypeList = [...planTypeList];
    newPlanTypeList.splice(index, 1);
    newPlanTypeList.unshift(urlPlan);
    return newPlanTypeList;
  }
  return planTypeList;
}

export default (planMapJSON) => {
  const { plan = BASE_PLAN_SUB_TYPES.PRO } = pageConfig;
  return defaultMapper(
    {
      ...planMapJSON[RoomConnectorCategories.ROOM_CONNECTOR],
      typeNameKey: 'billing.rc.title',
      planNameKey: 'billing.rc.title',
      dependBasePlanTypeList: reorderDependBasePlans(getPlanTypeByCategory(plan), dependMeetingPlanTypeList),
      billingCycleDependBasePlanTypeList,
    },
    planTypes.ROOM_CONNECTOR,
  ).map((p) => {
    return {
      ...p,
      min: 1,
      max: 9999,
      unit: planUnitMap.port,
      planModel: PlanModelInfo.license
    };
  });
};
